import type React from "react";

import GoogleAuth from "../../../components/auth/google-auth/GoogleAuth";
import RegisterForm from "../../../components/auth/register-form/RegisterForm";
import { Separator } from "../../../components/ui/separator";

const Register: React.FC = () => {
  return (
    <div className='flex min-h-screen items-center justify-center bg-muted/50 px-4 py-8'>
      <div className='w-full max-w-md space-y-6'>
        <RegisterForm />

        <div className='relative'>
          <div className='absolute inset-0 flex items-center'>
            <Separator className='w-full' />
          </div>
          <div className='relative flex justify-center text-xs uppercase'>
            <span className='bg-background px-2 text-muted-foreground'>Or continue with</span>
          </div>
        </div>

        <GoogleAuth />
      </div>
    </div>
  );
};

export default Register;
